module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticClass: "platinfo",
    attrs: {
      "span": 4
    }
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('div', {
    staticClass: "platname"
  }, [_c('el-image', {
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "src": _vm.logoUrl,
      "fit": "cover"
    }
  })], 1), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.logout.apply(null, arguments)
      }
    }
  }, [_vm._v("退出登录")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.changePwd.apply(null, arguments)
      }
    }
  }, [_vm._v("修改密码")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20,
      "align": "right"
    }
  }, [_c('div', {
    staticClass: "sysinfo"
  }, [_c('div', [_vm._v("版本号：" + _vm._s(_vm.version))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.baseURL))])])])], 1), _vm._v(" "), _c('el-col', {
    ref: "main",
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('aside', {
    staticClass: "menu-expanded",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.spreadOrCollapse($event)
      }
    }
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.$route.path,
      "unique-opened": "",
      "router": "",
      "background-color": "#414141",
      "text-color": "#97a0a8",
      "active-text-color": "#fff",
      "collapse": _vm.isCollapse
    },
    on: {
      "open": _vm.handleopen,
      "close": _vm.handleclose,
      "select": _vm.handleselect
    }
  }, [_vm._l((_vm.$router.options.routes), function(item, index) {
    return [(!item.hidden && !item.leaf && item.children.length > 0 && _vm.menuArray.some(function (a) { return a.value === item.name; })) ? _c('el-submenu', {
      key: index,
      attrs: {
        "index": index + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _vm._l((item.children), function(child) {
      return [(_vm.menuArray.some(function (a) { return a.value === child.name; })) ? _c('el-menu-item', {
        key: child.path,
        staticClass: "submenu-content",
        attrs: {
          "index": child.path
        }
      }, [_c('span', {
        attrs: {
          "slot": "title"
        },
        slot: "title"
      }, [_vm._v(_vm._s(child.name))])]) : _vm._e()]
    })], 2) : _vm._e(), _vm._v(" "), (item.leaf && item.children.length > 0 && _vm.menuArray.some(function (a) { return a.value === item.children[0].name; })) ? _c('el-menu-item', {
      key: item.children[0].name,
      attrs: {
        "index": item.children[0].path
      }
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(item.children[0].name))])]) : _vm._e()]
  })], 2)], 1), _vm._v(" "), _c('section', {
    ref: "container",
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": "感谢使用本系统",
      "visible": _vm.dialogVisible,
      "width": "400px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "logOutTip"
  }, [_vm._v("期待您的再次使用，正在退出......")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bc6247d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 707
// module chunks = 1